import { Component } from 'react'
import invariant from 'invariant'
import PropTypes from 'prop-types'

/* WithIsScrolled is a Higher Order Component to wrap around components
 * that has interactions during onScroll events. Helps maintain performance
 * and a smooth scrolling experience
 */
class WithIsScrolled extends Component {
  state = {
    isScrolled: false,
  };

  componentWillMount() {
    const { children } = this.props
    invariant(typeof children === 'function', 'The children prop is expected to be a function')
  }

  componentDidMount() {
    // Learn more about how { passive: true } improves scrolling performance
    // https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener#Improving_scrolling_performance_with_passive_listeners
    window.addEventListener(
      'scroll', this.onScroll, {
        passive: true,
      }
    )

    // Check if it's already down the page, then activate the sticky component
    this.onScroll()
  }

  componentWillUnmount() {
    window.removeEventListener(
      'scroll', this.onScroll, {
        passive: true,
      }
    )
  }

  onScroll = () => {
    const { isScrolled } = this.state
    const pageScrolled = (window.pageYOffset || document.body.scrollTop) > 0

    if (pageScrolled !== isScrolled) {
      this.setState({
        isScrolled: pageScrolled,
      })
    }
  };

  render() {
    const { children } = this.props
    return children(this.state)
  }
}

WithIsScrolled.propTypes = {
  children: PropTypes.func.isRequired,
}

export default WithIsScrolled
